import * as React from 'react';
import { Route } from 'react-router';
import Emit from './containers/Emit';
import Matrix from './containers/Matrix';
// import Quote from './containers/Quote';
import Success from './containers/Success';

export default function App() {
  return (
    <>
      {/* <Route exact={true} path="/" component={Quote} /> */}
      <Route exact={true} path="/" component={Matrix} />
      <Route exact={true} path="/emit" component={Emit} />
      <Route exact={true} path="/success" component={Success} />
    </>
  );
}
